import React, { useEffect, useState } from "react";
import axios from "../../constents/axios";

import Courses from "../StudentJourney/Courses";
const Index = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
const [selected , setSelected] = useState(false)
const handelSelection = ()=>{
  setSelected(true)
}
 console.log(selected,"selected");
 
  return (
    <section>
      <div className="container">
        <div className="row">
          <div className="col">
            <Courses handelSelection={handelSelection}/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Index;
